import "./form.scss";
import Loading from "react-loader-spinner";
import { withLanguage, withDictionary } from "../../assets/js/contexts";
import { useLang } from "../../helpers/language";

const SubmitCareerForm = ({ contactLabels, tab,sent,formik }) => {
	const { lang } = useLang();

	return (
		<div id='submitCareer' className={`tabform ${!tab ? "d-none" : ""}`}>
			{sent ? <Loading type='Oval' className='loader' color='#ffbe03' /> : null}
      <input type="hidden" name="message_type" value="Career Form" />
				<div className='row'>
					<div className='col-md-6'>
						<div className='form-control' data-icon='person'>
							<input
								type='text'
								placeholder={contactLabels.name[lang]}
								onChange={formik.handleChange}
								name="name"
								onBlur={formik.handleBlur}
								value={formik.values.name}
								className={`${formik.touched.name && !!formik.errors.name && 'border-danger'}`}
							/>
							<i />
						</div>
					</div>
					<div className='col-md-6'>
						<div className='form-control'>
							<select name='category' className='form-select' onChange={formik.handleChange} value={formik.values.category}>
								<option>{contactLabels.selectCategoryTitle[lang]}</option>
								{contactLabels.selectCategory.map((item, index) => {
									return <option key={index}>{item.title[lang]}</option>;
								})}{" "}
							</select>
						</div>
					</div>
				</div>
				<div className='row'>
					<div className='col-md-12'>
						<div className='form-control'>
							<input
								type='text'
								placeholder={contactLabels.title[lang]}
								onChange={formik.handleChange}
								name="subject"
								onBlur={formik.handleBlur}
								value={formik.values.subject}
								className={`${formik.touched.subject && !!formik.errors.subject && 'border-danger'}`}
							/>
						</div>
					</div>
				</div>
				<div className='form-control'>
					<textarea
						placeholder={contactLabels.message[lang]}
						rows='5'
						onChange={formik.handleChange}
						name="description"
						onBlur={formik.handleBlur}
						value={formik.values.description}
						className={`${formik.touched.description && !!formik.errors.description && 'border-danger'}`}
					/>
				</div>
				<div
					className='d-flex justify-content-center buttons'
					style={{ marginTop: 9 }}
				>
					<label className='file-upload'>
						<input type='file' name="file" />
						Attach a CV
					</label>
					<button className='round black' aria-label='round black' onClick={formik.handleSubmit}>
						{contactLabels.button[lang]}
					</button>
					<i />
				</div>
		</div>
	);
};

export default withLanguage(withDictionary(SubmitCareerForm));
